import { Button, Col, Container, Row } from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";

import styles from "Pages/NotFound/NotFound.module.css";

export default function NotFound() {
    const navigate = useNavigate();
    const { state } = useLocation();

    const previousUrl = state.url;

    // This gets set in layout and certain urls are excluded, but it can't be excluded there
    // because the url could before being navigated to this component could be any random string
    localStorage.removeItem("lastPage");

    const goHome = () => {
        navigate("/");
    };

    const goBack = () => {
        navigate(-1);
    };

    return (
        <Container>
            <Row className={styles.row}>
                <Col xs={12} className={styles.col}>
                    <h1>Page not found:</h1>
                    <h3>{previousUrl}</h3>
                    <Button onClick={goBack}>Go to last page</Button>&nbsp;
                    <Button onClick={goHome}>Go to home page</Button>
                </Col>
            </Row>
        </Container>
    );
}
